import React from 'react';
import { userData } from '../../data';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Skills = () => {
    useDocumentTitle('Skills | Jerel Layog');

    return (
    <section className="content-pane w-full h-full flex flex-col pt-16 md:pt-32 2xl:pt-48 overflow-y-auto custom-scrollbar px-4 sm:px-8 md:pl-16 2xl:pl-24 relative z-20" tabIndex={-1} aria-labelledby="heading-skills">
        <h2 id="heading-skills" className="text-4xl sm:text-5xl md:text-7xl 2xl:text-8xl font-bebas text-white bg-black px-4 2xl:px-6 py-2 2xl:py-3 border-4 md:border-[6px] 2xl:border-[8px] border-white shadow-[6px_6px_0_#000] md:shadow-[12px_12px_0_#000] 2xl:shadow-[18px_18px_0_#000] mb-6 md:mb-8 2xl:mb-12 transform md:-rotate-3 2xl:-rotate-4 relative z-20 text-center md:text-left inline-block w-fit">
            SKILLS
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-10 2xl:gap-14 w-full max-w-5xl 2xl:max-w-6xl relative z-20 pb-32 2xl:pb-40 pr-4 2xl:pr-6">
            {userData.skills.map((skillGroup, idx) => (
                <div key={skillGroup.category} className={`relative group focus-within:scale-105 2xl:focus-within:scale-[1.08] hover:scale-105 2xl:hover:scale-[1.08] transition-transform transform ${idx % 2 === 0 ? 'md:-rotate-2 2xl:-rotate-3' : 'md:rotate-1 2xl:rotate-2'}`}>
                    <div className="absolute inset-0 bg-[#FFF200] transform translate-x-1 translate-y-1 md:translate-x-2 md:translate-y-2 2xl:translate-x-3 2xl:translate-y-3" aria-hidden="true"></div>
                    <div className="relative bg-black text-white p-4 md:p-6 2xl:p-8 border-4 md:border-[6px] 2xl:border-[8px] border-white h-full flex flex-col">
                        <h3 className="text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-black italic mb-3 md:mb-4 2xl:mb-6 text-[#FF5555] uppercase tracking-tight">{skillGroup.category}</h3>
                        <ul className="flex flex-wrap gap-1.5 md:gap-2 2xl:gap-3" aria-label={`List of ${skillGroup.category}`}>
                            {skillGroup.items.map(item => (
                                <li key={item} className="bg-white text-black font-bold px-2 md:px-3 2xl:px-4 py-0.5 md:py-1 2xl:py-1.5 text-xs md:text-sm 2xl:text-base transform rotate-1 2xl:rotate-2 border-2 2xl:border-[3px] border-black hover:bg-[#A30000] hover:text-white hover:-translate-y-1 2xl:hover:-translate-y-2 transition-all cursor-default shadow-[2px_2px_0_#000] 2xl:shadow-[4px_4px_0_#000]">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    </section>
    );
};

export default Skills;